import React from 'react';
import ColorTag from '../ColorTag/ColorTag';

interface ColorTagDNRProps {}

const ColorTagDNR: React.FC<ColorTagDNRProps> = props => {
  return <ColorTag className="ColorTagDNR" color="red">DNR</ColorTag>
}

export default ColorTagDNR;